/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import { Modal, Input, Form, Button, message, Checkbox, Row, Col, Space } from "antd";
import { useEffect, useState } from "react";
import API from "../../../services/API";
import LoaderComponent from "../../Loader";
import ReleasePhoneNumber from "./Profile/ReleasePhoneNumber";

function UpdateAccountModal({
  editAccountModalVisible,
  closeUpdateAccountModal,
  userId,
  userData,
  refetchUserData,
}) {
  const [visible, setVisible] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);
  const [form] = Form.useForm();
  const [updatePhone, setUpdatePhone] = useState(false);
  const [updateAddress, setUpdateAddress] = useState(false);
  const [updateEmail, setUpdateEmail] = useState(false);
  const [updateSsn, setUpdateSsn] = useState(false);
  const [updateDob, setUpdateDob] = useState(false);
  const [updateName, setUpdateName] = useState(false);
  let isRegistered = userData?.status === "REGISTERED_USER";
  const defaultFieldsConfig = {wrapperCol:{md:24}};

  const getDataValues = () => ({
    phoneNumber: userData?.phoneNumber,
    addressLineOne: userData?.addressLineOne,
    addressLineTwo: userData?.addressLineTwo,
    city: userData?.city,
    state: userData?.state,
    zip: userData?.zip,
    email: userData?.email,
    ssn: userData?.ssn,
    dob: userData?.dob && userData?.dob !== 'null' ? userData?.dob : null,
    firstName: userData?.firstName,
    lastName: userData?.lastName,
    middleName: userData?.middleName,
  })

  useEffect(() => {
    setVisible(editAccountModalVisible);
  }, [editAccountModalVisible]);

  useEffect(() => {
    form.setFieldsValue(getDataValues());
  }, [userData]);

  const closeModal = () => {
    form.resetFields();
    setUpdatePhone(false);
    setUpdateAddress(false);
    setUpdateEmail(false);
    setUpdateSsn(false);
    setUpdateDob(false);
    
    setVisible(false);
    closeUpdateAccountModal(false);
  };

  const triggerSubmitBtn = () => {
    form.submit();
  };

  const updateAccount = async (data) => {
    showModalLoading(true);

    try {
      let updatedObject = {};
      updatedObject.userId = userData?.userId;

      if (updatePhone && data.phoneNumber) {
        updatedObject.phoneNumber = data.phoneNumber;
      }

      if (updateAddress && (data.addressLineOne || data.addressLineTwo || data.city || data.state || data.zip)) {
        updatedObject.address = {
          line1: data.addressLineOne,
          line2: data.addressLineTwo,
          city: data.city,
          state: data.state,
          zip: data.zip,
          country: "US",
        };
      }

      if (updateEmail && data.email) {
        updatedObject.email = data.email;
      }

      if (updateName && (data.firstName || data.lastName || data.middleName)) {
        updatedObject.name = {
          firstName: data.firstName,
          lastName: data.lastName,
          middleName: data.middleName || null,
        };
      }

      const personalData = {};

      if (updateSsn && data.ssn) {
        personalData.ssn = data.ssn;
      }

      if (updateDob && data.dob) {
        personalData.dob = data.dob;
      }

      if (Object.keys(personalData).length > 0) {
        updatedObject.personal = personalData;
      }

      await API.updateUserAccount(updatedObject, isRegistered);
      if (refetchUserData) {
        refetchUserData();
      }
    } catch (ex) {
      message.error(ex?.response?.data?.error_message);
    } finally {
      closeUpdateAccountModal(false);
      showModalLoading(false);
    }
  };

  const onFinishFailed = () => {
    message.error("Please see the validation errors");
  };

  return (
      <Modal
          title={"Update Account"}
          centered
          mask={true}
          maskClosable={true}
          okText={"Update"}
          destroyOnClose={true}
          closable={true}
          visible={visible}
          onOk={triggerSubmitBtn}
          onCancel={closeModal}
          className="confirm-modal"
      >
        {!modalLoading && (
            <Form
                name="basic"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                  ...getDataValues()
                }}
                onFinish={updateAccount}
                form={form}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
              <Space direction="vertical" style={{ width: '100%'}}>
                <Row>
                  <Col span="12">
                    <Checkbox onChange={(e) => setUpdatePhone(e.target.checked)} > <h3>Phone Number</h3></Checkbox>
                  </Col>
                  <Col span="12">
                    <Form.Item
                      name="phoneNumber"
                      rules={[
                        {
                          pattern:
                              /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d+)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i,
                          message: "Please enter a valid phone number!",
                        },
                      ]}
                      {...defaultFieldsConfig}
                    >
                      <Input placeholder="Phone Number"
                      disabled={!updatePhone}
                      suffix={
                        <ReleasePhoneNumber
                          userId={userId}
                          phoneNumber={userData?.phoneNumber}
                          reloadData={() => { closeModal(); refetchUserData(); }}
                        />
                      } />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col span="12">
                    <Checkbox onChange={(e) => setUpdateAddress(e.target.checked)}><h3>Address Fields</h3></Checkbox>
                  </Col>
                  <Col span="12">
                    <>
                      <Form.Item
                        help="Address Line One"
                        name="addressLineOne"
                        {...defaultFieldsConfig}
                      >
                        <Input disabled={!updateAddress} />
                      </Form.Item>

                      <Form.Item help="Address Line Two" name="addressLineTwo" {...defaultFieldsConfig}>
                        <Input disabled={!updateAddress} />
                      </Form.Item>

                      <Form.Item
                        help="Zip"
                        name="zip"
                        rules={[
                          {
                            pattern: /^\d{5}(?:[-\s]\d{4})?$/,
                            message: "Please enter a valid zip code!",
                          },
                        ]}
                        {...defaultFieldsConfig}
                      >
                        <Input disabled={!updateAddress} />
                      </Form.Item>

                      <Form.Item
                        help="City"
                        name="city"
                        {...defaultFieldsConfig}
                      >
                        <Input disabled={!updateAddress} />
                      </Form.Item>

                      <Form.Item
                        help="State"
                        name="state"
                        {...defaultFieldsConfig}
                      >
                        <Input disabled={!updateAddress} />
                      </Form.Item>
                    </>
                  </Col>
                </Row>

                <Row>
                  <Col span="12">
                    <Checkbox onChange={(e) => setUpdateEmail(e.target.checked)}><h3>Email Address</h3></Checkbox>
                  </Col>
                  <Col span="12">
                      <Form.Item
                        name="email"
                        rules={[
                          {
                            type: "email",
                            message: "Please enter a valid email address!",
                          },
                        ]}
                        {...defaultFieldsConfig}
                      >
                        <Input placeholder="Email" disabled={!updateEmail}/>
                      </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col span="12">
                    <Checkbox
                      onChange={(e) => setUpdateSsn(e.target.checked)}>
                        <h3>SSN</h3>
                    </Checkbox>
                  </Col>
                  <Col span="12">
                    <Form.Item
                      name="ssn"
                      rules={[
                        {
                          pattern: value => !updateSsn || /^\d{9}$/,
                          message: "Please enter a valid SSN!",
                        },
                      ]}
                      {...defaultFieldsConfig}
                    >
                      <Input placeholder="SSN" disabled={!updateSsn}/>
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col span="12">
                    <Checkbox
                      onChange={(e) => setUpdateDob(e.target.checked)}>
                        <h3>Date of Birth</h3>
                    </Checkbox>
                  </Col>
                  <Col span="12">
                    <Form.Item
                      name="dob"
                      rules = {[
                        {
                          pattern: /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/,
                          message: "Please enter a valid DOB!"
                        }
                      ]}
                      {...defaultFieldsConfig}
                    >
                      <Input placeholder="YYYY-MM-DD" disabled={!updateDob} />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col span="12">
                    <Checkbox
                      onChange={(e) => setUpdateName(e.target.checked)}>
                        <h3>Name</h3>
                    </Checkbox>
                  </Col>
                  <Col span="12">
                    <Form.Item
                      name="firstName"
                      rules = {[
                        {
                          required: true,
                          message: "First Name is required!"
                        },
                        {
                          pattern: /^[a-zA-Z '-]+$/,
                          message: "Please enter a valid First Name!"
                        }
                      ]}
                      help="First Name"
                      {...defaultFieldsConfig}
                    >
                      <Input disabled={!updateName} />
                    </Form.Item>
                    <Form.Item
                      name="middleName"
                      rules = {[
                        {
                          required: false,
                          message: "Middle Name is required!"
                        },
                        {
                          pattern: /^[a-zA-Z '-]+$/,
                          message: "Please enter a valid Middle Name!"
                        }
                      ]}
                      help="Middle Name"
                      {...defaultFieldsConfig}
                    >
                      <Input disabled={!updateName} />
                    </Form.Item>
                    <Form.Item
                      name="lastName"
                      rules = {[
                        {
                          required: true,
                          message: "Last Name is required!"
                        },
                        {
                          pattern: /^[a-zA-Z '-]+$/,
                          message: "Please enter a valid Last Name!"
                        }
                      ]}
                      help="Last Name"
                      {...defaultFieldsConfig}
                    >
                      <Input disabled={!updateName} />
                    </Form.Item>
                  </Col>
                </Row>
              </Space>
            </Form>
        )}
        {modalLoading && <LoaderComponent tip={"Updating account"} />}
      </Modal>
  );
}

export default UpdateAccountModal;